module.exports = __webpack_public_path__ + "static/media/logos_166x50_GUT.0e96925a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_166x50_GUT.jpg
// module id = 215
// module chunks = 0